<template>
  <v-container>
    <v-flex>
      <v-card class="elevation-1">
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">Transaction report</v-toolbar-title>
        </v-toolbar>
        <v-flex>
          <v-card-title>
            <v-flex xs12 lg3 class="pt-3 pl-3">
              <v-select
                :items="agencies"
                  v-model="selectedAgency"
                  label="Agencies"
                  item-text="company"
                  item-value="id"
                  bottom
                  autocomplete
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title>{{data.item.company}} {{data.item.id}}</v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3">
              <v-select
                :items="typeItems"
                v-model="typeSelected"
                item-text="name"
                item-value="value"
                label="Type"
                bottom
              ></v-select>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3">
              <v-menu
                  lazy
                  :close-on-content-click="false"
                  v-model="menuFrom"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Date from:"
                    v-model="dateFrom"
                    prepend-icon="event"
                  ></v-text-field>
                  <v-date-picker v-model="dateFrom" no-title scrollable actions>
                    <template slot-scope="{ save, cancel }">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                        <v-btn flat color="primary" @click="save">OK</v-btn>
                      </v-card-actions>
                    </template>
                  </v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3">
              <v-menu
                lazy
                :close-on-content-click="false"
                v-model="menuTo"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Date to:"
                  v-model="dateTo"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="dateTo" no-title scrollable actions>
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                      <v-btn flat color="primary" @click="save">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg1 class="pl-5" >
              <v-btn
                color="primary"
                @click="searchFilter"
                dark
                right
                block
              > Search
              </v-btn>
            </v-flex>
          </v-card-title>
        </v-flex>
        <v-divider></v-divider>
          <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :rows-per-page-items="rows"
              :pagination.sync="pagination"
              :loading="loading"
            >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.id }}</td>
              <td class="text-xs-center">{{ props.item.created_at }}</td>
              <td class="text-xs-center green--text" v-if="props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === 1">$ {{ props.item.amount }}</td>
              <td class="text-xs-center green--text" v-if="props.item.type === 'CANCEL' ">$ {{ props.item.amount }}</td>
              <td class="text-xs-center red--text" v-if="props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === -1">$ {{ props.item.amount }}</td>
              <td class="text-xs-center red--text" v-if="props.item.type === 'SALE'">$ {{ props.item.amount }}</td>
              <td class="text-xs-center">{{ props.item.type | furs}}</td>
              <td class="text-xs-center" v-if="props.item.type === 'SALE' || props.item.type === 'CANCEL'"> <router-link :to="'/agency/issued_policies/show/' + props.item.policy.uuid">{{ props.item.policy.uuid }}</router-link>   </td>
              <td class="text-xs-center" v-if="props.item.type === 'ADJUSTMENT'">-</td>
              <td class="text-xs-center" v-if="props.item.type === 'SALE' || props.item.type === 'CANCEL'">-</td>
              <td class="text-xs-center" v-if="props.item.type === 'ADJUSTMENT'">{{ props.item.actor.company || props.item.actor.email }}</td>
              <td class="text-xs-center"><router-link :to="'/agency/agencies/show/' + props.item.account.id">{{ props.item.account.company }}</router-link></td>
              <td class="text-xs-center">{{ props.item.description }}</td>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              Showing {{ pageStart }} to {{ pageStop }} Total: {{ items.length}}
            </template>
          </v-data-table>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment"
export default {
  data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      calculated: null,
      agencies: [{company: 'All', id : null}],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [
          { name: 'All', value: null },
          { name: 'Adjustment', value: 'ADJUSTMENT' },
          { name: 'Sale', value: 'SALE' },
          { name: 'Cancel', value: 'CANCEL' }
        ],
      searchQuery: '',
      pagination: {
          sortBy: 'id'
        },
      headers: [
        {
          text: "Transaction ID",
          value: "id",
          sortable: true,
          align: "center"
        },
        { 
          text: "Date", 
          value: "date", 
          sortable: false, 
          align: "cetner" },
        {
          text: "Credit/Debit",
          value: "type",
          sortable: false,
          align: "center"
        },
        { 
          text: "Type", 
          value: "type", 
          sortable: false, 
          align: "center" 
        },
        {
          text: "Insurance policy",
          value: "total",
          sortable: false,
          align: "center"
        },
        {
          text: "Creator",
          value: "canceled",
          sortable: false,
          align: "center"
        },
        { text: "Agency", 
          value: "total", 
          sortable: false, 
          align: "center" 
        },
        {
          text: "Description",
          value: "holder",
          sortable: false,
          align: "center"
        }
      ],
      items: []
    };
  },
  filters: {
    booleanify: function(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    },
    formatId: function(value) {
      return value.substring(2);
    },
    furs: function(string) {
      let smalling = string.toLowerCase();
      let uppin = smalling.charAt(0).toUpperCase() + smalling.slice(1);
      return uppin;
    }
  },
  methods: {
    getTransactions(){
      axios
        .get("/transactions")
        .then(response => {
          this.items = response.data.transactions;
          this.loading = false;
      });
    },
    agencyInfo(agencyId, extraVal = null) {
      let agencyData = '';
      this.agencies.forEach(function (agency) {
        if (agency.id == agencyId) {
          if (extraVal){
            agencyData = agency[extraVal];
          } else {
            agencyData = agency.id;
          }
        }
      })
      return agencyData;
    },
    getAgencies(){
      axios
        .get("/agencies")
        .then(res => {
          for (var user in res.data.users) {
            this.agencies.push(res.data.users[user]);
          }
        });
    },
    buildQuery() {
      this.searchQuery = ''
      if (this.selectedAgency){
        this.searchQuery+= 'agency_id=' + this.selectedAgency + "&";
      }
      if (this.typeSelected){
        this.searchQuery+= 'type=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery+= 'from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery+= 'to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter() {
      this.loading = true;
      this.items = {};
      this.buildQuery()
      axios.get("/transactions?" + this.searchQuery).then(response => {
        this.items = response.data.transactions;
        this.loading = false;
      });
    }
  },
  created() {
    this.getTransactions()
    this.getAgencies()
    this.pagination.descending = !this.pagination.descending
  }
};
</script>

<style scoped>
  a   {
  /* Applies to all unvisited links */
  text-decoration:  none;
  color: #28AFAF !important;
  } 
</style>



// WEBPACK FOOTER //
// src/components/agency/Transactions/Transactions.vue